import request from "@/utils/request";
import { Message } from "element-ui";
import { encryptor } from "@/utils/encryptor.js";

export function login(params) {
  return new Promise((resolve, reject) => {
    const secureRequest = encryptor.generateSecureRequest("api.member.weblogin", params);
    request({
      method: "post",
      data: secureRequest,
    })
      .then(res => {
        if (res.statusCode >= 500) {
          Message.error(res.msg || "出错啦");
          return reject();
        }
        let _res = encryptor.decryptAES(res.data);
        if (!_res.state) {
          Message.error(_res.msg || "出错啦");
          return reject();
        }
        let data = _res.data;
        resolve({ data });
      })
      .catch(err => {
        Message.error("出错啦");
        reject();
      });
  });
}

export function getuserinfo(params) {
  return new Promise((resolve, reject) => {
    const secureRequest = encryptor.generateSecureRequest("api.member.getuserinfo", params);
    request({
      method: "post",
      data: secureRequest,
    })
      .then(res => {
        if (res.statusCode >= 500) {
          Message.error(res.msg || "出错啦");
          return reject();
        }
        let _res = encryptor.decryptAES(res.data);
        if (!_res.state) {
          Message.error(_res.msg || "出错啦");
          return reject();
        }
        let data = _res.data;
        resolve({ data });
      })
      .catch(err => {
        Message.error("出错啦");
        reject();
      });
  });
}
